import Store from './components/Store.vue';
import ShoppingCart from './components/ShoppingCart.vue';
import ProductDetails from './components/ProductDetails.vue';
import Login from './components/auth/Login.vue';
import Register from './components/auth/Register.vue';

import GProfile from './components/GProfile.vue';
import Messages from './components/Messages.vue';
import Wholesalers from './components/Wholesalers.vue';

import About from './components/About.vue';
import Home from './components/Home.vue';

export const routes = [
	{path: '/home', component: Home, name: 'home'},
	{path: '/gProfile', component: GProfile, name: 'gProfile'},
	{path: '/messages', component: Messages, name: 'messages'},
	{path: '/wholesalers', component: Wholesalers, name: 'wholesalers'},

	{path: '/cart', component: ShoppingCart, name: 'shoppingcart'},
	{path: '/products', component: Store, name: 'products'},

	{path: '/product/:id', component: ProductDetails, name: 'product'},

	{path: '/login', component: Login, name: 'login', onlyGuest: true },
	{path: '/register', component: Register, name: 'register', onlyGuest: true},

	{path: '/pages/about', component: About, name: 'about'},

	{path: '/:orgId', component: Store, name: 'mainpage'},
	{path: '*', redirect: '/:orgId' },
];